export const StudentCourseSummaryTranslations = {
  TABS_LESSONS_TITLE: {
    es: 'Lecciones',
    en: 'Lessons',
    cat: 'Leccions',
    eus: 'Ikastarak',
    pt: 'Aulas'
  },
  TABS_LIVE_RECORDS_TITLE: {
    es: 'Clases grabadas',
    en: 'Recorded classes',
    cat: 'Classes gravades',
    eus: 'Gordetako ariketak',
    pt: 'Aulas gravadas'
  },
  TABS_DELIVERABLES_TITLE: {
    es: 'Entregables',
    en: 'Deliverables',
    cat: 'Entregables',
    eus: 'Entregagarriak',
    pt: 'Entregáveis'
  },
  TABS_INTRODUCTION_TITLE: {
    es: 'Introducción',
    en: 'Introduction',
    cat: 'Introducció',
    eus: 'Sarrera',
    pt: 'Introdução'
  },
  TABS_COMPLEMENTARY_MATERIAL_TITLE: {
    es: 'Material complementario',
    en: 'Complementary material',
    cat: 'Material complementari',
    eus: 'Material osagarria',
    pt: 'Material complementar'
  },
  TABS_COURSE_INFO_TITLE: {
    es: 'Información del curso',
    en: 'Course information',
    cat: 'Informació del curs',
    eus: 'Kurtsoaren informazioa',
    pt: 'Informação do curso'
  },
  TABS_COURSE_MATERIAL_TITLE: {
    es: 'Material descargable',
    en: 'Downloadable material',
    cat: 'Material descarregable',
    eus: 'Material deskargagarria',
    pt: 'Material descarregável'
  },
  VIDEO_DESCRIPTION: {
    es: 'Video · {{duration}} minutos',
    en: 'Video · {{duration}} minutes',
    cat: 'Video · {{duration}} minuts',
    eus: 'Bideoa · {{duration}} minutu',
    pt: 'Vídeo · {{duration}} minutos'
  },
  PDF_DESCRIPTION: {
    es: 'Lectura',
    en: 'Reading',
    cat: 'Lectura',
    eus: 'Irakurketa',
    pt: 'Leitura'
  },
  QUIZ_DESCRIPTION: {
    es: 'Test · {{questions}} preguntas',
    en: 'Test · {{questions}} questions',
    cat: 'Test · {{questions}} preguntes',
    eus: 'Test · {{questions}} galdera',
    pt: 'Teste · {{questions}} questões'
  },
  QUIZ_DESCRIPTION_WITH_SCORE: {
    es: 'Test · Nota: {{score}}',
    en: 'Test · Score: {{score}}',
    cat: 'Test · Nota: {{score}}',
    eus: 'Test · Nota: {{score}}',
    pt: 'Teste · Nota: {{score}}'
  },
  DELIVERABLE_DESCRIPTION: {
    es: 'Entregable · Pendiente',
    en: 'Deliverable · Pending',
    cat: 'Entregable · Pendent',
    eus: 'Entregagarria · Edozein',
    pt: 'Entregável · Pendente'
  },
  DELIVERABLE_DESCRIPTION_SENT: {
    es: 'Entregable · Enviado',
    en: 'Deliverable · Sent',
    cat: 'Entregable · Enviat',
    eus: 'Entregagarria · Bidali',
    pt: 'Entregável · Enviado'
  },
  DELIVERABLE_DESCRIPTION_WITH_SCORE: {
    es: 'Entregable · Nota: {{score}}',
    en: 'Deliverable · Score: {{score}}',
    cat: 'Entregable · Nota: {{score}}',
    eus: 'Entregagarria · Nota: {{score}}',
    pt: 'Entregável · Nota: {{score}}'
  },
  TEXT_DESCRIPTION: {
    es: 'Texto',
    en: 'Text',
    cat: 'Text',
    eus: 'Testua',
    pt: 'Texto'
  },
  EMPTY_CONTENT_TITLE: {
    es: 'Aún no hay lecciones',
    en: 'No lessons yet',
    cat: 'Encara no hi ha leccions',
    eus: 'Oraindik ez dago ikastarak',
    pt: 'Ainda não há aulas'
  },
  EMPTY_CONTENT_DESCRIPTION: {
    es: 'El contenido del curso está en desarrollo.',
    en: 'The course content is under development.',
    cat: 'El contingut del curs està en desenvolupament.',
    eus: 'Kursuaren edukia garatzeko.',
    pt: 'O conteúdo do curso está em desenvolvimento.'
  },
  EMPTY_FILTERED_CONTENT_TITLE: {
    es: 'No se han encontrado temas',
    en: 'No sections found',
    cat: 'No seccions trobades',
    eus: 'Ez da gaiak aurkitu',
    pt: 'Não foram encontrados temas'
  },
  EMPTY_FILTERED_CONTENT_DESCRIPTION: {
    es: 'No tienes temas que coincidan con los filtros seleccionados.',
    en: 'No sections found that match the selected filters.',
    cat: 'No seccions trobades que coïncideixen amb els filtres seleccionats.',
    eus: 'Ez da gaiak aurkitu zituen filtrotatutakoak.',
    pt: 'Não foram encontrados temas que coincidam com os filtros selecionados.'
  },
  EMPTY_FAVORITE_CONTENT_TITLE: {
    es: 'No tienes lecciones favoritas',
    en: 'No favorite lessons',
    cat: 'No hi ha leccions favorites',
    eus: 'Ez dago favoritako ikastarak',
    pt: 'Não há aulas favoritas'
  },
  EMPTY_FAVORITE_CONTENT_DESCRIPTION: {
    es: 'Marca tus lecciones favoritas y tenlas siempre a mano.',
    en: 'Mark your favorite lessons and have them always at hand.',
    cat: 'Marca les teves leccions favorites i les tinguis sempre a mà.',
    eus: 'Egin zure favoritako ikastarak markatu eta beti gordetu.',
    pt: 'Marque as aulas favoritas e mantenha-as sempre à mão.'
  },
  NEW: {
    es: 'Nuevo',
    en: 'New',
    cat: 'Nou',
    eus: 'Berria',
    pt: 'Novo'
  },
  SECTION: {
    es: 'Tema',
    en: 'Section',
    cat: 'Tema',
    eus: 'Gaia',
    pt: 'Tema'
  },
  STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  SCORE: {
    es: 'Nota en test',
    en: 'Score in test',
    cat: 'Nota en test',
    eus: 'Nota testean',
    pt: 'Nota no teste'
  },
  NO_MATERIAL_YET: {
    en: 'There is no material yet',
    es: 'No hay material todavía',
    cat: 'Encara no hi ha material',
    eus: 'Oraindik ez dago materialik',
    pt: 'Ainda não há material'
  },
  DOWNLOAD: {
    en: 'Download',
    es: 'Descargar',
    cat: 'Descarregar',
    eus: 'Jaitsi',
    pt: 'Descarregar'
  },
  DOWNLOAD_ALL: {
    en: 'Download all',
    es: 'Descargar todo',
    cat: 'Descarregar tot',
    eus: 'Jaitsi dena',
    pt: 'Descarregar tudo'
  },
  DAYS_one: {
    es: '1 día',
    en: '1 day',
    cat: '1 dia',
    eus: '1 egun',
    pt: '1 dia'
  },
  DAYS_other: {
    es: '{{count}} días',
    en: '{{count}} days',
    cat: '{{count}} dies',
    eus: '{{count}} egun',
    pt: '{{count}} dias'
  },
  PROGRESS: {
    es: 'Progreso',
    en: 'Progress',
    cat: 'Progrés',
    eus: 'Aurrerapena',
    pt: 'Progresso'
  },
  WELCOME_TITLE: {
    es: '¡Bienvenido',
    en: 'Welcome',
    cat: '¡Benvingut',
    eus: '¡Ongi etorri',
    pt: 'Bem-vindo'
  },
  SUPER_NAME: {
    es: 'Súper {{ name }}!',
    en: 'Super {{ name }}!',
    cat: 'Súper {{ name }}!',
    eus: 'Súper {{ name }}!',
    pt: 'Super {{ name }}!'
  },
  TOOLS_TITLE: {
    es: '¿Cómo lo vas a lograr?',
    en: 'How are you going to achieve it?',
    cat: 'Com ho aconseguiràs?',
    eus: 'Nola lortuko duzu?',
    pt: 'Como vai conseguir?'
  },
  USERNAME: {
    es: 'Nombre de usuario',
    en: 'Username',
    cat: 'Nom d`usuari',
    eus: 'Erabiltzaile izena',
    pt: 'Nome de usuário'
  },
  NAME: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  LAST_NAME: {
    es: 'Apellidos',
    en: 'Surname',
    cat: 'Cognoms',
    eus: 'Abizenak',
    pt: 'Apelido'
  },
  LEGAL_ID: {
    es: 'NIE/NIF',
    en: 'NIE/NIF',
    cat: 'NIE/NIF',
    eus: 'NIE/NIF',
    pt: 'NIE/NIF'
  },
  LEGAL_ID_PLACEHOLDER: {
    es: 'DNI, NIF, NIE o pasaporte',
    en: 'DNI, NIF, NIE or passport',
    cat: 'DNI, NIF, NIE o passaport',
    eus: 'DNI, NIF, NIE edo pasaportea',
    pt: 'DNI, NIF, NIE ou passaporte'
  },
  BIRTHDAY: {
    es: 'Fecha de nacimiento',
    en: 'Birthday',
    cat: 'Data de naixement',
    eus: 'Jaiotze data',
    pt: 'Data de nascimento'
  },
  NOTIFICATION_SETTINGS_TITLE: {
    es: 'Te avisaremos de las próximas convocatorias y exámenes',
    en: 'We will notify you of upcoming calls and exams',
    cat: 'T’avisarem de les properes convocatòries i exàmens',
    eus: 'Jakinaraziko dizugu hurrengo deialdi eta azterketetaz',
    pt: 'Notificaremos você sobre as próximas convocatórias e exames'
  },
  NOTIFICATION_SETTINGS_SUBTITLE: {
    es: 'Elige sobre qué regiones quieres ser notificado. Lo podrás configurar más tarde si lo prefieres.',
    en: 'Choose about which regions you want to be notified. You can configure it later if you prefer.',
    cat: 'Tria sobre quines regions vols ser notificat. Ho podràs configurar més tard si ho prefereixes.',
    eus: 'Hautatu zein eskualdeetan jakinarazi nahi duzun. Geroago konfiguratu dezakezu nahi baduzu.',
    pt: 'Escolha sobre quais regiões você deseja ser notificado. Você pode configurá-lo mais tarde se preferir.'
  },
  LATER: {
    es: 'Más adelante',
    en: 'Later',
    cat: 'Més endavant',
    eus: 'Geroago',
    pt: 'Mais tarde'
  },
  UNKNOWN_SCORE: {
    es: 'No lo sé aún',
    en: "I don't know yet",
    cat: 'Encara no ho sé',
    eus: 'Oraindik ez dakit',
    pt: 'Ainda não sei'
  },
  PREPARING_PLATFORM: {
    es: 'Si Batman no es nada sin Robin, tú sin plataforma tampoco. Tardará menos de un minuto (Flash es nuestro amigo). 😌',
    en: 'If Batman is nothing without Robin, you are nothing without a platform either. It will take less than a minute (Flash is our friend). 😌',
    cat: 'Si Batman no és res sense Robin, tu sense plataforma tampoc. Trigarà menys d`un minut (Flash és el nostre amic). 😌',
    eus: 'Batman ez da Robin gabe ezer, zuk plataforma gabe ere ez. Minutu baino gutxiago beharko du (Flash gure laguna da). 😌',
    pt: 'Se Batman não é nada sem Robin, você também não é nada sem uma plataforma. Demorará menos de um minuto (Flash é nosso amigo). 😌'
  },
  PLATFORM_READY: {
    es: '¡Ya tienes tu plataforma lista!',
    en: 'You already have your platform ready!',
    cat: 'Ja tens la teva plataforma llesta!',
    eus: 'Zure plataforma prest dago!',
    pt: 'Sua plataforma já está pronta!'
  },
  CONTRACT_TITLE: {
    es: 'Una última cosa antes de empezar',
    en: 'One last thing before we start',
    cat: 'Una última cosa abans de començar',
    eus: 'Azkenengo gauza bat hasi aurretik',
    pt: 'Uma última coisa antes de começarmos'
  },
  CONTRACT_SUBTITLE: {
    es: 'Necesitamos que aceptes las condiciones antes de poder continuar. Aquí te lo dejamos para que puedas leerlo:',
    en: 'We need you to accept the conditions before we can continue. We leave it here for you to read:',
    cat: 'Necessitem que acceptis les condicions abans de poder continuar. Aquí te`l deixem perquè puguis llegir-lo:',
    eus: 'Beharrezkoa da baldintzak onartzea jarraitzeko. Hemen utzi dizugu irakurtzeko:',
    pt: 'É necessário que aceite as condições antes de podermos continuar. Deixamos aqui para que possa ler:'
  },
  CONTRACT_HELP: {
    es: '¿Tienes dudas? Escríbenos a atencionalalumno@ucademy.com con el asunto «Contrato» y nos pondremos en contacto contigo para que puedas continuar con el estudio 😀',
    en: 'Do you have any doubts? Write us to atencionalalumno@ucademy.com with the subject "Contract" and we will contact you so you can continue with the study 😀',
    cat: 'Tens dubtes? Escriu-nos a atencionalalumno@ucademy.com amb l`assumpte «Contracte» i ens posarem en contacte amb tu perquè puguis continuar amb l`estudi 😀',
    eus: 'Zalantzak dituzu? Idatzi iezaguzu atencionalalumno@ucademy.com helbidera "Kontratua" gaiarekin eta zurekin harremanetan jarriko gara ikasketekin jarrai dezazun 😀',
    pt: 'Tem dúvidas? Escreva-nos para atencionalalumno@ucademy.com com o assunto "Contrato" e nós entraremos em contato com você para que você possa continuar com o estudo 😀'
  },
  ALL_SET: {
    es: '¡Todo listo!',
    en: 'All set',
    cat: 'Tot llest',
    eus: 'Denak prest',
    pt: 'Tudo pronto'
  },
  YOU_CAN_START: {
    es: 'Ya puedes empezar',
    en: 'You are ready to go',
    cat: 'Ja pots començar',
    eus: 'Orain hasi dezakezu',
    pt: 'Você está pronto para começar'
  },
  CONTRACT_SIGNED_SUCCESSFULLY: {
    es: '¡Contrato firmado correctamente! Encontrarás una copia en tu perfil.',
    en: 'Contract signed successfully! You will find a copy in your profile.',
    cat: 'Contracte signat correctament! Trobaràs una còpia al teu perfil.',
    eus: 'Kontratua ongi sinatu da! Kopi bat aurkituko duzu zure profila.',
    pt: 'Contrato assinado com sucesso! Você encontrará uma cópia no seu perfil.'
  },
  STUDY_STEPS_TITLE: {
    es: 'Vamos a ir pasito a pasito',
    en: 'We are going to take it step by step',
    cat: 'Anirem pas a pas',
    eus: 'Paso a paso joango gara',
    pt: 'Vamos passo a passo'
  },
  STUDY_STEPS_SUBTITLE: {
    es: '¡Cuidado! ¡Superhéroe en prácticas! Vamos a ir de la mano en todo momento para que no te pierdas y sepas lo que tienes que hacer.',
    en: 'Watch out! Superhero in training! We are going to go hand in hand at all times so you don`t get lost and know what you have to do.',
    cat: 'Atenció! Superheroi en pràctiques! Anirem de la mà en tot moment perquè no et perdis i sàpigues el que has de fer.',
    eus: 'Kontuz! Superheroi praktiketan! Gure artean joango gara beti ez galduz eta zer egin behar duzun jakin dezazun.',
    pt: 'Atenção! Super-herói em treinamento! Vamos andar juntos em todos os momentos para que você não se perca e saiba o que tem que fazer.'
  },
  STUDY_PLAN_TITLE: {
    es: 'Planificación de tu estudio',
    en: 'Planning your study',
    cat: 'Planificació del teu estudi',
    eus: 'Zure ikasketak planifikatzea',
    pt: 'Planeamento do seu estudo'
  },
  STUDY_PLAN_SUBTITLE: {
    es: 'Para que SIEMPRE sepas qué tienes que hacer, planificaré tu estudio por tareas diarias.',
    en: 'So you ALWAYS know what you have to do, I will plan your study by daily tasks.',
    cat: 'Perquè SEMPRE sàpigues què has de fer, planificaré el teu estudi per tasques diàries.',
    eus: 'ZER egin behar duzun beti jakiteko, zure ikasketak eguneko lanak eginez planifikatuko ditut',
    pt: 'Para que SEMPRE saiba o que tem de fazer, vou planificar o seu estudo por tarefas diárias.'
  },
  ONBOARDING_FOLLOW_UP_TITLE: {
    es: 'No te pierdas',
    en: 'Don`t get lost',
    cat: 'No et perdis',
    eus: 'Ez galdu',
    pt: 'Não perca'
  },
  ONBOARDING_FOLLOW_UP_SUBTITLE: {
    es: 'En la sección de inicio siempre te recomendaremos por dónde lo dejaste',
    en: 'In the home section we will always recommend where you left off',
    cat: 'A la secció d`inici sempre et recomanarem per on ho vas deixar',
    eus: 'Hasierako atalean beti gomendatuko dizugu non utzi zenuen',
    pt: 'Na secção de início, sempre vamos recomendar para onde você parou'
  },
  ONBOARDING_REWARDS_TITLE: {
    es: 'Recompensas',
    en: 'Rewards',
    cat: 'Recompenses',
    eus: 'Sariak',
    pt: 'Prémios'
  },
  ONBOARDING_REWARDS_SUBTITLE: {
    es: '¡Te daré puntos de conocimiento cada vez que hagas las cosas bien!',
    en: 'I will give you knowledge points every time you do things right!',
    cat: 'Et donaré punts de coneixement cada vegada que facis les coses bé!',
    eus: 'Zer egiten duzun bakoitzean, ezagutza puntuak emango dizkizut!',
    pt: 'Irei te dar pontos de conhecimento toda vez que fizer as coisas certas!'
  },
  GENERATING_PLATFORM: {
    es: 'Generando tu plataforma {{ name }}...',
    en: 'Generating your platform {{ name }}...',
    cat: 'Generant la teva plataforma {{ name }}...',
    eus: 'Zure plataforma sortzen {{ name }}...',
    pt: 'Gerando sua plataforma {{ name }}...'
  },
  THANKS_FOR_WAITING: {
    es: '¡Gracias por la espera {{ name }}!',
    en: 'Thanks for waiting {{ name }}!',
    cat: 'Gràcies per l`espera {{ name }}!',
    eus: 'Eskerrik asko itxaroten {{ name }}!',
    pt: 'Obrigado por esperar {{ name }}!'
  },
  NO_LIVE_EVENTS: {
    es: 'Aún no tienes clases programadas.',
    en: 'You have no scheduled classes.',
    cat: 'No tens classes programades.',
    eus: 'Ez duzu zuzeneko klaseak programatuta.',
    pt: 'Você não tem aulas agendadas.'
  },
  GET_20_POINTS: {
    es: 'Consigue 20 puntos',
    en: 'Get 20 points',
    cat: 'Aconsegueix 20 punts',
    eus: 'Lortu 20 puntu',
    pt: 'Obtenha 20 pontos'
  },
  VIEW_MORE_CLASSES: {
    es: 'Ver más',
    en: 'View more',
    cat: 'Veure més',
    eus: 'Ikusi gehiago',
    pt: 'Ver mais'
  },
  EMPTY_LIVE_RECORDS_TITLE: {
    es: 'Aún no hay grabaciones',
    en: 'No recordings yet',
    cat: 'Encara no hi ha grabacions',
    eus: 'Oraindik ez dago grabazioik',
    pt: 'Ainda não há gravações'
  },
  EMPTY_LIVE_RECORDS_CONTENT: {
    es: 'Aquí podrás ver las grabaciones de las clases en directo para repasarlas cuando quieras.',
    en: 'Here you can see the recordings of the live classes to review them whenever you want.',
    cat: 'Aquí podràs veure les grabacions de les classes en directe per repassar-les quan vulguis.',
    eus: 'Hemen ikusi ditzakezu direktu klaseen grabazioak errepikatzeko nahi duzunetan.',
    pt: 'Aqui você pode ver as gravações das aulas ao vivo para revisar quando quiser.'
  },
  GENERAL: {
    es: 'General',
    en: 'General',
    cat: 'General',
    eus: 'Orokorra',
    pt: 'Geral'
  },
  VIEW_MORE: {
    es: 'Ver más',
    en: 'View more',
    cat: 'Veure més',
    eus: 'Ikusi gehiago',
    pt: 'Ver mais'
  },
  VIEW_LESS: {
    es: 'Ver menos',
    en: 'View less',
    cat: 'Veure menys',
    eus: 'Ikusi gutxiago',
    pt: 'Ver menos'
  },
  CHANGE_COURSE: {
    es: 'Cambiar curso',
    en: 'Change course',
    cat: 'Canviar curs',
    eus: 'Aldatu kursua',
    pt: 'Mudar curso'
  },
  ACTIVITIES_COMPLETED: {
    es: '{{completed}}/{{total}} lecciones',
    en: '{{completed}}/{{total}} lessons',
    cat: '{{completed}}/{{total}} leccions',
    eus: '{{completed}}/{{total}} ikastarak',
    pt: '{{completed}}/{{total}} aulas'
  },
  ALL_ACTIVITIES_COMPLETED: {
    es: '{{completed}}/{{total}} lecciones completadas',
    en: '{{completed}}/{{total}} lessons completed',
    cat: '{{completed}}/{{total}} leccions completes',
    eus: '{{completed}}/{{total}} ikastarak osatuak',
    pt: '{{completed}}/{{total}} aulas completadas'
  },
  FILTERS: {
    es: 'Filtros:',
    en: 'Filters:',
    cat: 'Filtres:',
    eus: 'Fitroak:',
    pt: 'Filtros:'
  },
  FAVORITE_ADD: {
    es: 'Marcar lección como favorita',
    en: 'Mark lesson as favorite',
    cat: 'Marcar lecció com a favorita',
    eus: 'Leccióa favoritetara markatu',
    pt: 'Marcar aula como favorita'
  },
  FAVORITE_REMOVE: {
    es: 'Quitar de favoritas',
    en: 'Remove from favorites',
    cat: 'Eliminar de favoritas',
    eus: 'Ezabatu favoritetara',
    pt: 'Remover dos favoritos'
  },
  ALL_LESSONS: {
    es: 'Todas ({{count}})',
    en: 'All ({{count}})',
    cat: 'Totes ({{count}})',
    eus: 'Orokorra ({{count}})',
    pt: 'Todas ({{count}})'
  },
  FAVORITE_LESSONS: {
    es: 'Favoritas ({{count}})',
    en: 'Favorites ({{count}})',
    cat: 'Favorites ({{count}})',
    eus: 'Favoritak ({{count}})',
    pt: 'Favoritos ({{count}})'
  },
  MARK_AS_COMPLETED_INTRO_ACTIVITY: {
    es: 'Marcar como completada',
    en: 'Mark as completed',
    cat: 'Marcar com a completada',
    eus: 'Markatu osatuta',
    pt: 'Marcar como completada'
  },
  MARK_AS_INCOMPLETED_INTRO_ACTIVITY: {
    es: 'Completada',
    en: 'Completed',
    cat: 'Completada',
    eus: 'Osatuta',
    pt: 'Completada'
  },
  CLASS_COUNTER: {
    es: '{{count}} clases',
    en: '{{count}} classes',
    cat: '{{count}} classes',
    eus: '{{count}} ariketak',
    pt: '{{count}} aulas'
  }
};
